import { useParams } from "react-router-dom";
import { DocEditor } from "@/features/docs/DocEditor";
import { DocList } from "@/features/docs/DocList";

/** 목록과 본문은 경로로 갈린다. 에디터 패키지는 본문에서만 늦춰 불러온다. */
export function ProjectDocsPage() {
  const { docId } = useParams();
  if (docId) return <DocEditor docId={docId} />;
  return <DocList />;
}
